import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { ReactHookForm } from '../../components/hook-form/react-hook-form.component';
import { Icons } from '../../assets/icons';
import FormInput from '../../components/hook-form/form-input.component';
import { ApiErrorComponent } from '../../components/api-error.component';
import { useReactHookForm } from '../../hooks/useReactHookForm';
import { passwordApiKeyStore } from '../../api/password-api-key-store';
import { useSaveData } from '../../hooks/useSaveData';
import * as Yup from 'yup';
import { loginApiKeyStore } from '../../api/login-api-key-store';
import { useSnackbar } from '../../hooks/use-snackbar.hook';

const styling = {
  textStyle: { cursor: 'pointer', fontWeight: 'normal', textDecoration: 'underline' },
};

const validationSchema = Yup.object().shape({
  userEmail: Yup.string().required('Email is required').email('Invalid email address'),
});

export const ForgotPasswordEmail = () => {
  const { showSnackbar } = useSnackbar();
  const { isLoading, mutateAsync } = useSaveData<any>(passwordApiKeyStore.resetPasswordEmail());
  const form = useReactHookForm({
    values: {
      userEmail: '',
    },
    yupSchema: validationSchema,
  });

  const handleSubmit = async (data: any) => {
    mutateAsync({
      data: {
        userEmail: data?.userEmail,
      },
    }).then((data) => showSnackbar(!data ? '' : 'A password reset link has been sent to your email', 'success'));
  };

  const handleForgotPassword = () => {
    window.location.href = '/';
  };

  return (
    <ReactHookForm
      formName="FORGOT_PASSWORD_FORM"
      onSubmit={handleSubmit}
      formContextProps={form}
      // isBusy={isLoading || isLoadingUser}
    >
      <Grid container className="loginform" justifyContent="center" alignItems="center">
        <Grid item xs={4} className="loginWrap">
          <Stack className="brandName">
            <img src={Icons.Logo} alt="SI Track" />
          </Stack>
          <Box>
            <FormInput label="Email" name="userEmail" maxLength={250} autoFocus isShrink={true} />
          </Box>
          {/* <Box>
                        <ApiErrorComponent isError={isError} errorRespnse={error} />
                    </Box> */}
          <Box>
            <Button type="submit" variant="contained" disableElevation size="medium" fullWidth>
              Send
            </Button>
          </Box>
          <Box>
            <Grid
              container
              direction="row"
              sx={{
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
              }}
            >
              <div onClick={handleForgotPassword} className="flex-end">
                <Typography variant="body2" style={styling.textStyle}>
                  back to login
                </Typography>
              </div>
            </Grid>
          </Box>
          <Typography variant="body2" className="loginfooter">
            © {new Date().getFullYear()} Specialty Inspectors, LLC. All Right Reserved.
          </Typography>
        </Grid>
      </Grid>
    </ReactHookForm>
  );
};
